import { FunctionComponent } from "react";
import TemplateForm from "../../../fragments/forms/TemplateForm";
import CustomModal from "../CustomModal";

interface IChooseTemplateModalProps {
    onMessageSaveHandler?: (e: string) => void;
    onCloseHandler?: () => void;
}

const ChooseTemplateModal: FunctionComponent<IChooseTemplateModalProps> = ({ onMessageSaveHandler, onCloseHandler }) => {
    return (
        <CustomModal
            headingText={'Choose From Templates'}
            closeButton
            bodyPadding={"0 24px 24px 24px;"}
        >
            <TemplateForm
                formType="chooseTemplate"
                onMessageSaveHandler={onMessageSaveHandler}
                onCloseHandler={onCloseHandler}
                showNameField={false}
                showPrivateField={false}
                primaryButtonLabel="Use template"
                cancelButtonLabel="Cancel"
            />
        </CustomModal>
    )
}

export default ChooseTemplateModal